import * as React from "react";
import IconButtonV2 from "../../../components/IconButtonV2";
import { useTheme } from "styled-components";

export function ExitButton(props:{onClick: ()=>void}) {
  const theme = useTheme();
  return (
    <IconButtonV2
      type="close"
      size="md"
      color={theme.textLight}
      onClick={props.onClick}
      selectedBackground={false}
    />
  );
}
